import type { DeleteTemplateRequestBody } from "@/common/types/templates";

import { useState } from "react";

import { deleteTemplate as deleteTemplateService } from "@/services/templates";

export const useDeleteTemplate = (): {
  deleteTemplate: (body: DeleteTemplateRequestBody) => Promise<void>;
  result: boolean | null;
  loading: boolean;
  error: boolean;
} => {
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const deleteTemplate = async (
    body: DeleteTemplateRequestBody
  ): Promise<void> => {
    setLoading(true);
    setError(false);

    try {
      await deleteTemplateService(body);

      setResult(true);
      setLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };

  return { deleteTemplate, result, loading, error };
};
